import PropTypes from "prop-types"
import React, {Fragment} from "react"

const Header = ({ siteTitle }) => (
  <header>
    <Fragment />
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
